import { useEffect, useState } from "react";

import styles from "./SmartSummary.module.css";
import close_20 from "./../../images/close-20.svg";
import parentStyles from "../home/Home.module.css";

export function SmartSummary(props) {
  if (!props.showAiSummary) {
    return null;
  }

  const aiSummary = atob(props.aiSummary);

  return (
    <div className={styles.originalwarrantymodal}>
      <div className={styles.originalwarrantymodalinner}>
        <div
          data-w-id="4c1bb755-fb92-5c2e-4fc4-1f52edc09338"
          className={parentStyles.closeModalBlock + " " + parentStyles.closeModalBlockAbsolute}
        >
          <img
            src={close_20}
            loading="lazy"
            alt=""
            className="close-modal-icon"
            onClick={() => props.setShowAiSummary(false)}
          />
        </div>

        <div className={`${styles["ai-summary-modal-titleblock"]}`}>
          <h3 className={`${styles["ai-summary-vehicle-title"]}`}>{props.year} {props.make} {props.model} {props.trim}</h3>
          <div>Here’s an AI summary based on this vehicle’s features and highlights:</div>
        </div>

        <div className={`${styles["w-richtext"]}`} dangerouslySetInnerHTML={{ __html: aiSummary }}>
        </div>
        <div
          onClick={() => props.setShowAiSummary(false)}
          className={`${styles["button-large"]}`}>View Full Window Sticker</div>
      </div>
    </div>
  );
}
